import { IconProps } from "../types";
export const PngIcon = ({ src, width, height }: IconProps) => (
  <img
    src={`/img/png/${src}`}
    alt={src}
    width={width}
    height={height}
    style={{ borderRadius: "8px" }} // You can adjust the value (e.g., "50%" for a circle)
  />
);
